import { useEffect } from "react";
import { useLocation } from "react-router";

// Handles scroll on route changes:
// - With a hash, scrolls to the matching element (retrying briefly while the
//   target section mounts, e.g. when arriving on the home page from another page).
// - Without a hash, resets to the top.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    let frame: number;

    const tryScroll = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (attempts < 20) {
        attempts += 1;
        frame = window.requestAnimationFrame(tryScroll);
      }
    };

    tryScroll();

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [pathname, hash]);

  return null;
};
